import React, { useState, useRef, useEffect } from "react";
import ResponseRenderer from "./ResponseRenderer";

// Reveal complete lines so markdown tables become chartable as soon as they
// contain a complete header and data row.
const LINE_INTERVAL_MS = 60;

const TypewriterText = ({ text, onComplete, onScroll, isDarkMode }) => {
  const [revealedLines, setRevealedLines] = useState(0);
  const linesRef = useRef([]);
  const revealedLinesRef = useRef(0);
  const timerRef = useRef(null);
  const onCompleteRef = useRef(onComplete);
  const onScrollRef = useRef(onScroll);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    onScrollRef.current = onScroll;
  }, [onScroll]);

  useEffect(() => {
    const newLines = text.split("\n");
    linesRef.current = newLines;
    const startFrom = Math.min(revealedLinesRef.current, newLines.length);

    if (timerRef.current) clearInterval(timerRef.current);

    if (startFrom === 0) {
      revealedLinesRef.current = 0;
      setRevealedLines(0);
    }

    timerRef.current = setInterval(() => {
      const next = revealedLinesRef.current + 1;
      revealedLinesRef.current = next;
      setRevealedLines(next);
      onScrollRef.current?.();

      if (next >= linesRef.current.length) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        onCompleteRef.current?.();
      }
    }, LINE_INTERVAL_MS);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [text]);

  const displayedText = linesRef.current.slice(0, revealedLines).join("\n");
  if (!displayedText) return null;

  return <ResponseRenderer content={displayedText} isDarkMode={isDarkMode} />;
};

export default TypewriterText;
